if (!Array.prototype.$shuffle) {
	Array.prototype.$shuffle = function() {
		for (let i = this.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1))
			;[this[i], this[j]] = [this[j], this[i]] // eslint-disable-line no-param-reassign
		}

		return this
	}
}

if (!Array.$unique) {
	Array.prototype.$unique = function() {
		var a = this.concat()
		for (var i = 0; i < a.length; ++i) {
			for (var j = i + 1; j < a.length; ++j) {
				if (typeof a[i] == 'object') {
					if (JSON.stringify(a[i]) === JSON.stringify(a[j])) {
						a.splice(j--, 1)
					}
				} else {
					if (a[i] === a[j]) {
						a.splice(j--, 1)
					}
				}
			}
		}

		return a
	}
}

if (!Object.assign) {
	Object.defineProperty(Object, 'assign', {
		enumerable: false,
		configurable: true,
		writable: true,
		value: function(target) {
			'use strict'
			if (target === undefined || target === null) {
				throw new TypeError('Cannot convert first argument to object')
			}

			var to = Object(target)
			for (var i = 1; i < arguments.length; i++) {
				var nextSource = arguments[i]
				if (nextSource === undefined || nextSource === null) {
					continue
				}
				nextSource = Object(nextSource)

				var keysArray = Object.keys(Object(nextSource))
				for (
					var nextIndex = 0, len = keysArray.length;
					nextIndex < len;
					nextIndex++
				) {
					var nextKey = keysArray[nextIndex]
					var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey)
					if (desc !== undefined && desc.enumerable) {
						to[nextKey] = nextSource[nextKey]
					}
				}
			}
			return to
		}
	})
}

if (!Object.$flat) {
	Object.defineProperty(Object, '$flat', {
		value: target => {
			let newObj = {}
			Object.keys(target).forEach(key => {
				if (!!target[key] && typeof target[key] === 'object') {
					Object.keys(target[key]).forEach(innerKey => {
						newObj[innerKey] = target[key][innerKey]
					})
				} else {
					newObj[key] = target[key]
				}
			})
			return newObj
		}
	})
}

if (!Number.prototype.$toReais) {
	Number.prototype.$toReais = function() {
		return this.toLocaleString('pt-BR', {
			style: 'currency',
			currency: 'BRL'
		})
	}
}

if (!String.prototype.$toCapitalCase) {
	String.prototype.$toCapitalCase = function() {
		return this.charAt(0).toUpperCase() + this.slice(1)
	}
}

if (!String.prototype.$replaceAccentsAndCedilha) {
	/**
	 * Replace accents and cedilha
	 */
	String.prototype.$replaceAccentsAndCedilha = function() {
		return String.prototype.normalize
			? this.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
			: this
	}
}
